<div class="container">
  <!-- Title -->
  <div class="text-center">
    <strong class="text-center py-2" style="color: #8e0e00; font-size: 1.5rem"
      >Monthly Summary Report</strong
    >
  </div>
  <!-- Filter Row (External) -->
  <div class="row mb-3 mt-3">
    <div class="col">
      <label>Type of Requestor</label>
      <select class="form-select" (change)="onUserTypeChange($event)">
        <option value="">All</option>
        <option
          *ngFor="let userType of userTypeList"
          [value]="userType.userTypeID"
        >
          {{ userType.userType }}
        </option>
      </select>
    </div>
    <div class="col">
      <label>Select Year</label>
      <select class="form-select" (change)="onYearChange($event)">
        <option value="">Select Year</option>
        <option *ngFor="let year of years" [value]="year">{{ year }}</option>
      </select>
    </div>
    <!-- <div class="col">
      <label>Select Month</label>
      <select class="form-select" (change)="onMonthChange($event)">
        <option value="">All</option>
        <option *ngFor="let month of months" [value]="month.id">
          {{ month.name }}
        </option>
      </select>
    </div> -->
    <div class="col">
      <label>Select City</label>
      <select class="form-select" (change)="onCityChange($event)">
        <option value="">All</option>
        <option *ngFor="let city of cityList" [value]="city.id">
          {{ city.cityName }}
        </option>
      </select>
    </div>
    <div class="col">
      <label>Select Zone</label>
      <select class="form-select" (change)="onZoneChange($event)">
        <option value="">All</option>
        <option *ngFor="let zone of zoneList" [value]="zone.zoneId">
          {{ zone.zoneName }}
        </option>
      </select>
    </div>
  </div>

  <!-- Export/Print Buttons -->
  <div class="d-flex justify-content-start mb-3 mt-2">
    <button
      ngbTooltip="Export To Excel"
      class="btn btn-success mr-2"
      (click)="exportToExcel()"
    >
      <span><i class="bi bi-box-arrow-up me-2"></i></span>
      Export
    </button>
    <button
      ngbTooltip="Print"
      class="btn btn-info mr-2 ms-2"
      (click)="exportToPDF()"
    >
      <span><i class="bi bi-printer me-2"></i></span>
      Print
    </button>
    <button
      ngbTooltip="Clear Filter"
      class="btn btn-warning ms-2"
      (click)="clearFilters()"
    >
      <span><i class="bi bi-x-circle me-2"></i></span>
      Clear Filter
    </button>
  </div>

  <!-- Data Table -->
  <div class="card shadow-lg p-3">
    <div class="d-flex align-items-center gap-3 ms-auto">
      <!-- From Date -->
      <div class="d-flex align-items-center">
        <label for="fromDate" class="form-label mb-0 me-2 text-nowrap"
          >From Date</label
        >
        <input
          type="date"
          id="fromDate"
          [(ngModel)]="ngFromDate"
          (change)="onFromDateChange($event)"
          class="form-control"
        />
      </div>

      <!-- To Date -->
      <div class="d-flex align-items-center">
        <label for="toDate" class="form-label mb-0 me-2 text-nowrap"
          >To Date</label
        >
        <input
          type="date"
          id="toDate"
          [(ngModel)]="ngToDate"
          (change)="onToDateChange($event)"
          class="form-control"
          [disabled]="!isToDateShow"
        />
      </div>
    </div>

    <table class="table table-bordered table-striped mt-2">
      <thead class="thead-light">
        <tr>
          <!-- <th>Year</th> -->
          <th>Month</th>
          <th>Number of Containers Booked (NOS)</th>
          <th>Number of Trips Achieved (NOS)</th>
          <th>Total Quantity Disposed (m³)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="pagedData?.length === 0">
          <td colspan="7" class="text-center fw-bold">No Data Found</td>
        </tr>
        <tr *ngFor="let order of pagedData">
          <!-- <td>{{ yearsList }}</td> -->
          <td>{{ order.month }}</td>
          <td>{{ order.noOfContainerBooked }}</td>
          <td>{{ order.noOfTripAchieved }}</td>
          <td>{{ order.totalTonDisposed }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="">
          <td>Total</td>
          <td>{{ totalContainers }}</td>
          <td>{{ totalTrips }}</td>
          <td>{{ totalQuantity }}</td>
        </tr>
      </tfoot>
    </table>
    <!-- Pagination Controls -->
    <div class="d-flex justify-content-end mt-2">
      <div *ngIf="filteredList?.length > 0" class="text-muted mb-3">
        <strong
          >Showing {{ (page - 1) * pageSize + 1 }} to
          {{
            page * pageSize > filteredList?.length
              ? filteredList?.length
              : page * pageSize
          }}
          of {{ filteredList?.length }} entries</strong
        >
      </div>
      <!-- <ngb-pagination class="" [collectionSize]="filteredList?.length" [(page)]="page" [pageSize]="pageSize"
        aria-label="page navigation" [boundaryLinks]="true" (pageChange)="onPageChange($event)"></ngb-pagination> -->
    </div>
  </div>
</div>
